// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-default-email-modal-title .MuiTypography-root{color:#fff}`, "",{"version":3,"sources":["webpack://./src/components/gms/ConfirmDefaultEmailDialog/ConfirmDefaultEmailDialog.scss"],"names":[],"mappings":"AAAA,uDACE,UAAA","sourcesContent":[".confirm-default-email-modal-title .MuiTypography-root {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
